import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=3110c10a&scoped=true&"
import script from "./AdminList.vue?vue&type=script&lang=js&"
export * from "./AdminList.vue?vue&type=script&lang=js&"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=3110c10a&lang=scss&scoped=true&"
import style1 from "./AdminList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3110c10a",
  null
  
)

export default component.exports